import {useState} from "react";
import {customAxios} from "../../customAxios";
import {OrderEditDto} from "../../../model/order/orderEditDto";
import notifier from "simple-react-notifications2";


export function useNewOrderEdit() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<OrderEditDto>();
    const [error, setError] = useState<Error>();

    async function execute(id: number) {
        try {
            setLoading(true);
            const fetched = await newOrderEdit(id);
            setData(fetched);
            return fetched;
        }
        catch (e) {
            setError(e as Error);
            notifier.error((e as Error).message)
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }

    return {loading, data, error, execute};
}


export async function newOrderEdit(id: number): Promise<OrderEditDto> {
    const response = await customAxios.get<OrderEditDto>(`/v1/order/${id}/edit`);
    return response.data;
}